import React from 'react';
import useScrollReveal from '../../hooks/useScrollReveal';

function Reveal({ as: Tag = 'div', style, className = '', children, ...rest }) {
  const [ref, visible] = useScrollReveal();
  return (
    <Tag
      ref={ref}
      style={style}
      className={`reveal ${visible ? 'reveal-visible' : ''} ${className}`.trim()}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default Reveal;
